"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit");

require("../styles/_no-organisations.scss");

function NoOrganisations() {
  return _react["default"].createElement("div", {
    className: "no-organisations"
  }, _react["default"].createElement("div", {
    className: "no-organisations__inner"
  }, _react["default"].createElement(_uiKit.Icon, {
    className: "no-organisations__inner__icon",
    name: "organisation",
    color: "monkey"
  }), _react["default"].createElement("div", {
    className: "no-organisations__inner__text"
  }, _react["default"].createElement("p", {
    className: "no-organisations__inner__text__header"
  }, "You don't seem to be a member of any Organisations"), _react["default"].createElement("p", {
    className: "no-organisations__inner__text__suggest"
  }, "You're in the HUB but you need an invite."))), _react["default"].createElement("p", {
    className: "no-organisations__assist"
  }, "Contact your Organisation / Team Admin or visit our", " ", _react["default"].createElement(_uiKit.LinkButton, null, "Help Center"), " ", "for more information."));
}

var _default = (0, _react.memo)(NoOrganisations);

exports["default"] = _default;